import React from 'react';

const BeginnerSummary = ({ summary }) => (
  <section className="card">
    <h2>Your chart at a glance</h2>
    <div className="chart-summary-grid">
      <article>
        <h4>Sun in {summary.sun?.sign || '—'}</h4>
        <p>Your Sun may describe your core vitality and conscious direction.</p>
      </article>
      <article>
        <h4>Moon in {summary.moon?.sign || '—'}</h4>
        <p>Your Moon may describe emotional rhythms and inner responsiveness.</p>
      </article>
      <article>
        <h4>Rising in {summary.ascendant?.sign || '—'}</h4>
        <p>Your Ascendant may describe how your energy meets the world.</p>
      </article>
    </div>
    <p className="chart-help">
      Astrology becomes clearer when you read symbols in combination, not in isolation.
    </p>
  </section>
);

export default BeginnerSummary;
